

//set favicon
export function setFavicon(url) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = url;

    document.getElementsByTagName("head")[0].appendChild(link);
}

export function capitalizeFirst(inputString) {
    if (inputString) {
        // Convert the entire string to lowercase
        const lowercasedString = inputString.toLowerCase();

        // Capitalize the first letter
        const capitalizedString = lowercasedString.charAt(0).toUpperCase() + lowercasedString.slice(1);

        return capitalizedString;
    }
}

//currency seperator
export const currencyseperator = (amount) => {
    return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0.00;
}

//calculate distance between user and the driver
export function getManualDistance(lat1, lon1, lat2, lon2) {
    if (!lat1 || !lon1 || !lat2 || !lon2) return 20000;
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d?.toFixed(2);

}

function toRad(Value) {
    return Value * Math.PI / 180;
}
